import * as Matter from 'matter-js';
import type { SceneDef } from './types';
import { createGround, createWalls } from './util';

export const sandbox: SceneDef = {
  labelKey: 'scene.sandbox',
  defaultPlaying: true,
  params: [
    { id: 'gravityX', labelKey: 'dim.gravityX', min: -2, max: 2, step: 0.1, value: 0 },
    { id: 'gravityY', labelKey: 'dim.gravityY', min: -2, max: 2, step: 0.1, value: 1 },
  ],
  build({ engine, world, dims, bounds }) {
    engine.gravity.x = dims.gravityX!;
    engine.gravity.y = dims.gravityY!;

    const ground = createGround(bounds);
    const walls = createWalls(bounds);
    const bodies = [ground, ...walls];
    Matter.World.add(world, bodies);

    return {
      bodies,
      constraints: [],
      dispose() {
        Matter.World.remove(world, bodies);
      },
    };
  },
};
